import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function DommusTooltipCondicionado({ condicao, texto, children, placement = "top" }) {
  if (!condicao) {
    return children;
  }

  return (
    <OverlayTrigger
      placement={placement}
      overlay={<Tooltip>{texto}</Tooltip>}
    >
        {children}
    </OverlayTrigger>
  );
}
